import React, { useState } from "react";
import { Box, Typography, Radio,FormControl, Select, MenuItem, InputLabel, } from "@mui/material";
import { styled } from "@mui/material/styles";


function BpRadio(props) {
  return <Radio 
  size='small'
  sx={{
    color: '#FFFFFFB2',
    '&.Mui-checked': {
      color: '#FF69B4',
      fontSize: '12px',
    },
  }} {...props} />;
}

const CategorySelector = ({ categories, selectedCategories, onCategoriesSelect }) => {

const currencySymbol =
  categories[Object.keys(categories)[0]]?.currency === "EUR"
    ? "€"
    : categories[Object.keys(categories)[0]]?.currency === "USD"
    ? "$"
    : categories[Object.keys(categories)[0]]?.currency === "GBP"
    ? "£"
    : categories[Object.keys(categories)[0]]?.currency=== "AUD"
    ? "A$"
    : categories[Object.keys(categories)[0]]?.currency; // No need to pass the currency symbol if it's not a currency value

  const formatSpend = (spend) => {
    if (spend >= 1_000_000_000) return `${currencySymbol}${(spend / 1_000_000_000).toFixed(0)}B`;
    if (spend >= 1_000_000) return `${currencySymbol}${(spend / 1_000_000).toFixed(0)}M`;
    if (spend >= 1_000) return `${currencySymbol}${(spend / 1_000).toFixed(0)}K`;
    return `${currencySymbol}${spend.toLocaleString()}`;
  };

  const handleSelect = (category) => {
    onCategoriesSelect([category]);
  };

  const [open, setOpen] = useState(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Box sx={{ maxWidth: "350px" }}>
      <Typography sx={{             fontStyle:'Inter',
            fontWeight: 600,
            fontSize:'20px',
            letterSpacing:'0.4px',
            lineHeight:'28px',
            color:'white',}}>
       Select Your Managed Categories
      </Typography>
          <Typography
            sx={{
              fontStyle:'Inter',
              fontWeight: 400,
              fontSize:'12px',
              letterSpacing:'0px',
              lineHeight:'20px',
              color:'#FFFFFF99',
              marginBottom:'20px',
              marginTop:'4px',
            }}
          >
        Choose the Categories You Oversee
          </Typography>
      {/* <Box sx={{ display: "flex", justifyContent: "space-between", paddingRight: "8px", marginBottom: "8px" }}>
        <Box sx={{ width: "24px" }} />
        <Typography sx={{ flex: 1, fontSize: "12px", fontWeight: "500", color: "gray" }}>Category</Typography>
        <Typography sx={{ fontSize: "12px", fontWeight: "500", color: "gray" }}>Spend</Typography>
      </Box> */}
      <Box sx={{ overflowY: "auto", maxHeight: "250px", "&::-webkit-scrollbar": { display: "none" }, marginBottom:'20px' }}>
      <FormControl fullWidth>
  <Select
    open={open}
    onOpen={handleOpen}
    onClose={handleClose}
    multiple
    value={selectedCategories}
    onChange={(e) => {
      const selectedValues = e.target.value;
      const added = selectedValues.filter(x => !selectedCategories.includes(x));
      const removed = selectedCategories.filter(x => !selectedValues.includes(x));
      added.forEach(category => handleSelect(category));
      removed.forEach(category => handleSelect(category));
    }}
    displayEmpty
    renderValue={(selected) => {
      if (selected.length === 0) {
        return "Select Category";
      }
      return selected.join(', ');
    }}

    MenuProps={{
      anchorOrigin: {
        vertical: 'bottom',
        horizontal: 'left',
      },
      transformOrigin: {
        vertical: 'top',
        horizontal: 'left',
      },
      PaperProps: {
        style: { 
          marginTop: '10px', // Add gap between select and menu
          backgroundColor: '#271B2A' ,
          border: '1px solid #FFFFFF0F',
          borderRadius:'12px',
          padding: '8px 16px', // Ensure consistent padding
        },
        sx: {
          '& .MuiList-root': {
            padding: 0,
          }
        }
      }
    }}
        sx={{
          '& .MuiSelect-select': {
            color: 'white',
            fontSize: '12px',
          },
          '& .MuiOutlinedInput-notchedOutline': {
              border: '1px solid #FFFFFF0F',
              borderRadius: '8px',
              padding:'8px 12px 8px 12px',
              justifyContent: 'space-between',
              color:'#FFFFFF0F',
              boxShadow: '0px 1px 2px 0px #1018280D',
          },
          '& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: '#FFFFFF0F !important', // Ensure hover border is the same
          },
          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: '#FFFFFF0F !important',
            borderWidth: '1px',
          },
          '& .MuiSvgIcon-root': {
            color: 'white',
          },
        }}
      >
        {Object.entries(categories)
          .sort(([, a], [, b]) => b.spend - a.spend)
          .map(([category, { spend }]) => (
            <MenuItem 
            key={category} 
            value={category} 
            sx={{
              fontSize: '12px', 
              fontWeight: '300',
              color: 'black',
              backgroundColor: '#271B2A',
              padding: '8px 16px', // Ensure consistent padding
              '&:hover': {
                backgroundColor: '#352336 !important', // Slightly lighter shade for hover state
                border:'1px solid #FFFFFF0F',
                borderRadius:'12px',
              },
              '&.Mui-selected': {
                backgroundColor: '#271B2A !important', // Keep same bg color when selected
              },
              '&.Mui-selected:hover': {
                backgroundColor: '#352336 !important', // Keep consistent hover on selected items
              }
            }}
          >
              <Box sx={{ display: 'flex', justifyContent: 'space-between', width: '100%',
               }}>
                <Typography sx={{ color: 'white',font:'Inter', fontWeight:400, fontSize:'14px',lineHeight:'150%', letterSpacing:'0px' }}>{category}</Typography>
                <Typography sx={{ color: 'white',font:'Inter', fontWeight:400, fontSize:'14px',lineHeight:'150%', letterSpacing:'0px' }}>{formatSpend(spend)}</Typography>
              </Box>
            </MenuItem>
          ))}
      </Select>
    </FormControl>
      </Box>
    </Box>
  );
};

export default CategorySelector;
